"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouTubeVideo = (_temp = _class = function (_Component) {
	(0, _inherits3.default)(YouTubeVideo, _Component);

	function YouTubeVideo(props) {
		(0, _classCallCheck3.default)(this, YouTubeVideo);
		return (0, _possibleConstructorReturn3.default)(this, (YouTubeVideo.__proto__ || (0, _getPrototypeOf2.default)(YouTubeVideo)).call(this, props));
	}

	(0, _createClass3.default)(YouTubeVideo, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "youtube-wrapper" },
				_react2.default.createElement(
					"div",
					{ className: "youtube" },
					_react2.default.createElement("iframe", {
						ref: "youtube-" + this.props.id,
						className: "youtube-frame",
						src: "https://www.youtube.com/embd/" + this.props.id + "?autoplay=1&enablejsapi=1"
					})
				)
			);
		}
	}]);
	return YouTubeVideo;
}(_react.Component), _class.propTypes = {
	id: _react.PropTypes.number.isRequired
}, _temp);
exports.default = YouTubeVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/YoutubeVideo.js
// module id = 229
// module chunks = 0